const countryLocales = [
  { country: "USD", code: "en-US" }, // United States
  { country: "INR", code: "en-IN" }, // India
  { country: "EUR", code: "de-DE" }, // Germany
  { country: "EUR", code: "fr-FR" }, // France
  { country: "JPY", code: "ja-JP" }, // Japan
  { country: "CNY", code: "zh-CN" }, // China
  { country: "GBP", code: "en-GB" }, // United Kingdom
  { country: "CAD", code: "en-CA" }, // Canada (English)
  { country: "CAD", code: "fr-CA" }, // Canada (French)
  { country: "AUD", code: "en-AU" }, // Australia
  { country: "BRL", code: "pt-BR" }, // Brazil
  { country: "MXN", code: "es-MX" }, // Mexico
  { country: "EUR", code: "es-ES" }, // Spain
  { country: "EUR", code: "it-IT" }, // Italy
  { country: "RUB", code: "ru-RU" }, // Russia
  { country: "KRW", code: "ko-KR" }, // South Korea
  { country: "EUR", code: "nl-NL" }, // Netherlands
  { country: "SEK", code: "sv-SE" }, // Sweden
  { country: "CHF", code: "de-CH" }, // Switzerland (German)
  { country: "CHF", code: "fr-CH" }, // Switzerland (French)
  { country: "CHF", code: "it-CH" }, // Switzerland (Italian)
  { country: "ARS", code: "es-AR" }, // Argentina
  { country: "ZAR", code: "en-ZA" }, // South Africa
  { country: "NGN", code: "en-NG" }, // Nigeria
  { country: "SAR", code: "ar-SA" }, // Saudi Arabia
  { country: "EGP", code: "ar-EG" }, // Egypt
  { country: "AED", code: "ar-AE" }, // United Arab Emirates
  { country: "TRY", code: "tr-TR" }, // Turkey
  { country: "ILS", code: "he-IL" }, // Israel
  { country: "EUR", code: "el-GR" }, // Greece
  { country: "EUR", code: "pt-PT" }, // Portugal
  { country: "PLN", code: "pl-PL" }, // Poland
  { country: "NOK", code: "nb-NO" }, // Norway
  { country: "DKK", code: "da-DK" }, // Denmark
  { country: "EUR", code: "fi-FI" }, // Finland
  { country: "VND", code: "vi-VN" }, // Vietnam
  { country: "THB", code: "th-TH" }, // Thailand
  { country: "MYR", code: "ms-MY" }, // Malaysia
  { country: "PHP", code: "en-PH" }, // Philippines
  { country: "IDR", code: "id-ID" }, // Indonesia
  { country: "PKR", code: "ur-PK" }, // Pakistan
  { country: "BDT", code: "bn-BD" }, // Bangladesh
  { country: "LKR", code: "si-LK" }, // Sri Lanka
  { country: "NZD", code: "en-NZ" }, // New Zealand
  { country: "EUR", code: "en-IE" }, // Ireland
  { country: "SGD", code: "en-SG" }, // Singapore
  { country: "EUR", code: "de-AT" }, // Austria
  { country: "EUR", code: "nl-BE" }, // Belgium (Dutch)
  { country: "EUR", code: "fr-BE" }, // Belgium (French)
  { country: "CZK", code: "cs-CZ" }, // Czech Republic
  { country: "HUF", code: "hu-HU" }, // Hungary
  { country: "RON", code: "ro-RO" }, // Romania
  { country: "BGN", code: "bg-BG" }, // Bulgaria
  { country: "UAH", code: "uk-UA" }, // Ukraine
  { country: "KZT", code: "kk-KZ" }, // Kazakhstan
  { country: "HKD", code: "zh-HK" }, // Hong Kong
  { country: "TWD", code: "zh-TW" }, // Taiwan
  { country: "ISK", code: "de-DE" }, // Island
];

export default countryLocales;
